import { Trash2, GripVertical } from "lucide-react";
import Spinner from "../../components/spinner";
import { useTranslation } from "react-i18next";
import { CHART_TYPES_VALUES } from "./char_types";
import PieChartEstados from "./pieChartEstados";
import SliceDetailModal from "./sliceDetailModal";
import { useState } from "react";
import ChartEstadoPagos from "./chart-estado-pagos";


export default function ChartCard({
    type,
    idCard,
    onRemove,
    isLoading = false,
    data = null,
    hasError = false,
    errorMessage = "",
}) {
    const { t } = useTranslation();

    const { lineData, listaEstadosPago, pieData } = data || {};

    const [sliceModal, setSliceModal] = useState(null);

    const getTitle = () => {
        return t(`label_${type}`);
    };

    const renderChart = () => {
        try {
            switch (type) {
                case CHART_TYPES_VALUES.piechartestados:
                    const safePieData = Array.isArray(pieData) ? pieData : [];
                    return (
                        <PieChartEstados
                            data={safePieData}
                            onSliceClick={(arg) => setSliceModal(arg?.payload ?? arg)}
                        />
                    );
                case CHART_TYPES_VALUES.estadopagos:
                    // console.log('listaEstadosPago');
                    // console.log(listaEstadosPago);
                    return (
                        <ChartEstadoPagos
                            data={listaEstadosPago}
                        />
                    );
                default:
                    return null;
            }
        } catch (err) {
            console.log('renderChart err', err);
            return null;
        }
    };

    return (
        <div className="h-full w-full bg-white rounded-2xl shadow-sm border border-neutral-200  overflow-hidden flex flex-col">
            <div className="flex items-center justify-between px-4 py-2 border-b border-neutral-200 ">
                <div className="flex items-center gap-2 text-sm font-medium">
                    <GripVertical className="drag-handle h-4 w-4 text-neutral-400" />
                    <span>{getTitle()}</span>
                </div>
                <button
                    onClick={() => onRemove(idCard)}
                    className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md border border-neutral-200  hover:bg-neutral-50"
                >
                    <Trash2 className="h-3.5 w-3.5" /> {t("label_quitar")}
                </button>
            </div>

            <div className="flex-1 p-2">
                {isLoading ? (
                    <div className="h-full w-full flex items-center justify-center">
                        <Spinner />
                    </div>
                ) : hasError ? (
                    <div className="h-full w-full flex items-center justify-center">
                        <div className="text-center text-red-500">
                            <p className="text-sm font-medium">{t("label_error_al_cargar_datos")}</p>
                            {errorMessage && (
                                <p className="text-xs text-neutral-500 mt-1">{errorMessage}</p>
                            )}
                        </div>
                    </div>
                ) : (
                    <>
                        {renderChart()}
                    </>
                )}
            </div>

            <SliceDetailModal slice={sliceModal} onClose={() => setSliceModal(null)} />
        </div>
    );
}

